var docWidth = window.innerWidth;
if(docWidth <= 991){
  
	    $( ".accordionize").accordion({
          disabled: false,
      	  collapsible: true,
		  active: false,			
	     });
}


//ACCORDION
widthMatch = window.matchMedia("(max-width: 990px)");
widthMatch.addEventListener('change', function(mm) {
    if (mm.matches) {   	  
		  $( ".accordionize").accordion({
          disabled: false,
      	  collapsible: true,
		  active: false,			
	     });	   	   
    }
    else {	
		$( ".accordionize").accordion({
        disabled: true,
      	collapsible: false,
		active: true,			
	  });	      
      $(".accordionize .ui-accordion-content").css({"display": "block", "height" : "auto"});
    }
});



if($(".thumbnail-list" ).length > 0){
    function disableButton(){     
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function() {      
      var ulWidth = $(".thumbnail-list").outerWidth()
      var uloffsetLeft = $(".thumbnail-list").offset().left
      var uloffsetRight = $(".thumbnail-list").offset().left + ulWidth
      var slide = $(".thumbnail-list__item:visible")
      var liCount = $(".thumbnail-list__item:visible").length-1
      var firstSlide = slide.eq(0)
      var lastSlide = slide.eq(10)      
      var firstSlideOffsetLeft = slide.eq(0).offset().left
      var lastSlideOffsetRight = slide.eq(liCount).offset().left  
      if(firstSlideOffsetLeft >= uloffsetLeft ){
          $(".slider-button--prev").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--prev").prop("disabled", false)
      }
      if(lastSlideOffsetRight <= uloffsetRight ){
          $(".slider-button--next").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--next").prop("disabled", false)
      }      
        }, 250));       
    }
  
    disableButton()    
    $(".imageSwatch").on("click", function(){
      disableButton() 
    })  
    $( ".thumbnail-list" ).on( "scroll", function() {
      disableButton()    
    })
}

if($(".video-bg").length > 0){
  function resizeVid(meth){
    var winWidth = $("html").outerWidth();
      var vidHeight = $(".banner").not(".invisible").find(".video-bg").outerHeight();
      if(winWidth < 1300){
        $(".banner").not(".invisible").css("min-height", vidHeight+"px")
        $(".banner").not(".invisible").find(".banner__content").css("min-height", vidHeight+"px")
        $(".banner").not(".invisible").find(".banner__content").css("padding-bottom", "0")
      }else{
        $(".banner").not(".invisible").css("min-height", "")
        $(".banner").not(".invisible").find(".banner__content").css("min-height", "") 
        $(".banner").not(".invisible").find(".banner__content").css("padding-bottom", "")
      }
  }  
  resizeVid("initial ")  
  $(".mega-menu-aden, .header__heading").on("click", "a", function(){
  resizeVid("click ")
  }) 
  $( window ).on( "resize", function() {
    resizeVid("resize ")
  }) 
}

 if (jQuery('.aristot-loader svg')) {
    setTimeout(function() { 
      jQuery('.aristot-loader svg').addClass('full-size');
    
      setTimeout(function() {
        jQuery('.logo-tm, .logo-inner').addClass('logo-visible');
      
        setTimeout(function() {
          jQuery('.aristot-loader').addClass('finished-loading');
        }, 1500);
      }, 1500);
    }, 100);
  }

jQuery(document).ready(function($) {
 $(function () {
       $(".homepage_banner .image-with-text__text-item").fadeIn(200)
    });
});

$(".js.product-form__input").find("input").on("click", function() {

  var title = $("a.product-form__submit").data("title");
  var href = $("a.product-form__submit").attr("href");
  var href_parts = href.split('?subject')  
  var color = $(this).val();
  var email = href_parts[0]+"?subject="+title+" - "+color
 
  if($(this).data("emailable") == true){
    $("a.product-form__submit").attr("href", email)
    $("a.product-form__submit").removeClass("hidden");
    $("button.product-form__submit").addClass("hidden")
  }else{
    $("a.product-form__submit").addClass("hidden");
    $("button.product-form__submit").removeClass("hidden")   
  }

})


function minimumCharacters(count){
 $(document).ready(function(){
  var path_name = window.location.pathname.split("/")[1]
  if(path_name == "search"){
      function getUrlVars()
      {
          var vars = [], hash;
          var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
          for(var i = 0; i < hashes.length; i++)
          {
              hash = hashes[i].split('=');
              vars.push(hash[0]);
              vars[hash[0]] = hash[1];
          }
          return vars;
      }
        
      var url_returned = getUrlVars()
      var q = url_returned.q
      var q_length = q.length
       
      if(q_length > 0 ){
        if(q_length < count ){        
        window.location = '?q='
          
        }
      }
    
  }

  
 
   
      function checkLength(){
        if(count > 1){
          if($(".search .search__input.field__input").val().trim().length >= count){
            $(".search-modal__content, .template-search__search").find(".field__label").addClass("ok")
          }else{
            $(".search-modal__content, .template-search__search").find(".field__label").removeClass("ok")    
          }         
        }    
      }
      
      checkLength()
      
      $('form.search').keyup(function(event){       
        checkLength()       
      })
      
      $('form.search').keydown(function(event){   
        if(event.keyCode == 13) {       
           if($(".search .search__input.field__input").val().trim().length < count){
              event.preventDefault();
           }else{
               
           }
        }
      });
      
      $(".search__button").on("click", function(){     
        if($(".search .search__input.field__input").val().trim().length < count){
            event.preventDefault();
         }else{
      
         }      
      }) 
    
  });
  
}

minimumCharacters(search_limit)


